import styles from "./Checkout.module.css";
import chevronLeft from "../../asset/icons/chevronLeft.png";
import whatsappIcon from "../../asset/icons/whatsapp.png";
import forward from "../../asset/icons/whiteForwardCircle.png";
import React, { useState, useEffect } from "react";
import cx from "classnames";
import Api from "../../utils/Api/Api";
import Helper from "../../utils/Helper";
import FleekIcon from "../../asset/icons/Brand_logo_Sq.png";
import { useSearchParams } from "react-router-dom";

import { ErrorFallback, createErrorDetails } from "../../components/Error/Error";
import { Loading } from "../../components/Loading/Loading";
import { useNavigate } from "react-router-dom";
import chevronRight from "../../asset/icons/chevronRight.png";
import { ToastContainer, toast } from "react-toastify";
import PercentCircle from "../../asset/icons/percentCircle.png";
import GreenPercentCircle from "../../asset/icons/GreenPercent.png";

import "react-toastify/dist/ReactToastify.css";
import { CoupanPopUp, CouponCongrats } from "../../components";

import {
  PaymentDetailsCard,
  UserPersonalDetailsCard,
  ProductPurchaseCard,
  FleekCoinDetailsCard,
  EarnFleekCoinsCard,
} from "../../components";

import UTMTracker from "../../utils/UTMTracker";
import { trackCheckoutInitiated, trackPaymentEvent, trackCustomEvent, CUSTOM_EVENTS, ANALYTICS_PROVIDERS } from '../../utils/analyticsService';
import * as amplitude from '@amplitude/analytics-browser';
import { PhonePeDrawer } from './PhonePeDrawer';

export const Checkout = ({ coupon = false }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paymentStatus = searchParams.get("status");
  const paymentErrorReason = searchParams.get("reason");
  const isMobile = Helper.isMobile();
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [hasError, setError] = useState(false);
  const [errorDetails, setErrorDetails] = useState(null);
  const [showCoupanPopUp, setShowCoupanPopup] = useState(false);
  const [showCoupanCongratsPopUp, setShowCoupanCongrats] = useState(false);
  const [userDetail, setUserDetail] = useState({ email: "", phone: "" });
  const [cartData, setCartData] = useState([]);
  const [fleekCoins, setFleekCoins] = useState([]);
  const [appliedCoupon, setAppliedCoupon] = useState({});
  // Fleek Coin State
  const [useFleekCoin, setUseFleekCoin] = useState(true);
  // Add state for payment banner visibility
  const [showPaymentBanner, setShowPaymentBanner] = useState(paymentStatus === 'failed');
  // Drawer state for PhonePe Custom
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerOrderId, setDrawerOrderId] = useState(null);
  const [drawerPaymentOptions, setDrawerPaymentOptions] = useState(null);
  const [drawerPaymentId, setDrawerPaymentId] = useState(null);
  const toggleCoupanPopUp = () => {
    if (coupon === true) {
      navigate("/checkout");
      return;
    }
    setShowCoupanPopup((pre_state) => !pre_state);
  };
  const toggleUseFleekCoin = () => {
    setUseFleekCoin((pre_state) => !pre_state);
  };
  const bundleId = localStorage.getItem("bundleId");

  const toggleCoupanCongrats = (data) => {
    setShowCoupanCongrats((pre_state) => !pre_state);
    if (data && data.coupon_code) {
      setAppliedCoupon(data);
    }
  };

  useEffect(() => {
    // Capture UTM parameters when the checkout page loads
    UTMTracker.captureUTMParams();

    const fetchCartData = async () => {
      try {
        const promise = [
          Api.GetFleekCoins(),
          Api.GetUserDetails(),
        ];

        // Separate try-catch for Juspay ID to handle 'already exists' case
        try {
          await Api.CreateJuspayId();
        } catch (err) {
          // Ignore if customer already exists
          if (err?.response?.data?.error_code !== 'unique') {
            console.error("Juspay ID creation failed:", err);
          }
        }

        if (bundleId) {
          const params = {
            bundle: bundleId,
          };
          promise.push(
            Api.BundleCheckout(params),
            Api.BundleDetails({ params: { bundle_id: bundleId } })
          );
        } else {
          promise.push(Api.GetCartItems());
        }
        let [
          { data: fleekCoins },
          { data: userDetails },
          { data },
          bundleDetails,
        ] = await Promise.all(promise);

        // Track checkout initiation with centralized service
        if (data) {
          trackCheckoutInitiated(data, {
            phone: userDetails?.phone_number,
            email: userDetails?.email
          });
        }

        if (bundleDetails?.data && bundleDetails.data.length) {
          data = [
            {
              subscription_plan: {
                service_name: "",
                plan_name: bundleDetails.data[0]?.bundle?.name || "",
                image_url: FleekIcon,
                bundle_id: bundleId,
              },
              discount_percentage_on_cost: data.discount_percentage_on_cost,
              actual_discounted_cost:
                data.final_payment_amount.coin_and_no_money,
              coin_used_percentage:
                Number(data.coin_used_percentage || 0) +
                data.discount_percentage_on_cost,
              cost: data.final_payment_amount.no_coin_and_no_money,
              mrp_price: bundleDetails.data[0]?.bundle?.mrp_price,
              coin_value_reserved: data.coin_value_reserved,
            },
          ];
        }
        setCartData(data);
        setFleekCoins(fleekCoins);
        setUserDetail({
          email: userDetails.email,
          phone: userDetails.phone_number,
        });
        
        // Amplitude user identification for logged-in users
        try {
          const phoneNo = localStorage.getItem('phoneNo');
          if (phoneNo) {
            amplitude.setUserId(phoneNo);

            // Create identify object and set properties
            const identifyObj = new amplitude.Identify()
              .set('phone', phoneNo)
              .set('email', userDetails?.email || '')
              .set('currency_type', bundleDetails?.data?.[0]?.bundle?.currency_type || data?.currency_type || 'INR')
              .set('last_checkout_visit', new Date().toISOString())
              .add('checkout_visits', 1);

            amplitude.identify(identifyObj);
          }
        } catch (amplitudeError) {
          console.error('Amplitude identification error:', amplitudeError);
        }
        
      } catch (err) {
        console.error('Checkout fetchCartData error:', err);
        setError(true);
        setErrorDetails(createErrorDetails(err, {
          componentName: 'Checkout',
          errorContext: 'checkout_data_fetch',
          apiCallsAttempted: ['GetFleekCoins', 'GetUserDetails', 'CreateJuspayId', bundleId ? 'BundleCheckout' : 'GetCartItems'],
          additionalContext: {
            bundle_id: bundleId,
            user_email: userDetail.email,
            user_phone: userDetail.phone,
            payment_status: paymentStatus,
            cart_items_count: cartData?.length || 0,
            fleek_coins_available: fleekCoins?.length || 0
          }
        }));
      }
      setLoading(false);
    };
    fetchCartData();
  }, []);

  const PlaceOrder = async () => {
    if (!isAbleButton() || buttonLoading) {
      return;
    }

    setButtonLoading(true);

    const payload = {
      screen_type: bundleId ? "bundle" : "buy_once",
      bundle: bundleId,
      use_coins: useFleekCoin,
      os: "web",
      email: userDetail.email,
      discount_coupon_id: appliedCoupon?.id,
      buy_now: bundleId ? true : undefined,
    };

    // Handle phone number based on currency type
    if (currencyType === 'usd') {
      payload.details = {
        user_entered_phone_number: userDetail.phone
      };
    } else {
      payload.phone_number = userDetail.phone;
    }

    try {
      // Add UTM attribution data to order payload
      const payloadWithUTM = UTMTracker.addUTMNotesToPayload(payload);
      let data = await Api.PlaceOrder(payloadWithUTM);

      if (!(data && data.data)) {
        // Track Payment Failed event
        trackPaymentEvent('failed', {
          amount: cartData[0]?.cost || 0,
          currency: 'INR',
          order_id: null,
          failure_reason: data?.response?.data?.error || "API Error"
        });

        toast(
          data?.response?.data?.error || "Something went wrong! Please try later."
        );
        setButtonLoading(false);
        return;
      } else {
        data = data.data;
      }

      // Track Payment Initiated event
      trackCustomEvent(CUSTOM_EVENTS.PAYMENT_INITIATED, {
        order_id: data.id,
        bundle_id: bundleId || null,
        use_fleek_coins: useFleekCoin,
        email: userDetail.email,
        phone: userDetail.phone,
        discount_applied: appliedCoupon?.id ? true : false,
        coupon_code: appliedCoupon?.coupon_code || null,
        page_url: window.location.href,
        timestamp: new Date().toISOString(),
        source: 'web'
      },ANALYTICS_PROVIDERS.AMPLITUDE);

      // Determine device type for backend routing
      const deviceType = isMobile ? "mobile" : "desktop";
      
      const payloadPayment = {
        type: "MKP",
        is_fleek_money_used: false,
        currency: "INR",
        new_placed_order_id: data.id,
        os: "web",
        return_url: `${process.env.REACT_APP_PAYMENT_URL}/order-confirmation?order_id=${data.id}`,
        notes: {
          customer_note: "Order from web checkout",
          device_type: deviceType,
          user_agent: navigator.userAgent,
        }
      };
      
      // ========== V4 PAYMENT FLOW LOGGING ==========
      console.log("=== V4 Payment Flow Started ===");
      console.log("Device Type:", deviceType);
      console.log("Order ID:", data.id);
      console.log("Return URL:", payloadPayment.return_url);
      console.log("Full Payment Payload:", JSON.stringify(payloadPayment, null, 2));
      
      // ✅ Use V4 API
      const { data: paymentData } = await Api.GetPaymentLinkV4(payloadPayment);

      console.log("=== V4 Payment Response Received ===");
      console.log("Full Response:", JSON.stringify(paymentData, null, 2));
      console.log("Gateway:", paymentData?.gateway);
      console.log("Is Purchase Done:", paymentData?.is_purchase_done);
      console.log("Payment URL:", paymentData?.payment_url);
      console.log("Payment Options:", JSON.stringify(paymentData?.payment_options, null, 2));

      // Handle V4 Payment Response - Three scenarios
      console.log("=== Determining Payment Flow Scenario ===");
      
      if (paymentData && paymentData.is_purchase_done) {
        // Scenario A: Immediate success (free or full coins)
        console.log("✅ Scenario A: Immediate Purchase Success (Free/Full Coins)");
        console.log("Order ID:", paymentData.order_id);
        console.log("Amount:", paymentData.amount || 0);
        
        trackPaymentEvent('success', {
          amount: paymentData.amount || 0,
          currency: 'INR',
          order_id: paymentData.order_id,
          payment_method: 'direct'
        });

        navigate(`/order?order_id=${paymentData.order_id}`);
      } else if (paymentData?.payment_options && (paymentData.gateway === 'phonepe_custom' || paymentData.gateway === 'phonepe')) {
        // Scenario B: PhonePe Custom UPI - Open drawer modal
        // Backend can return either 'phonepe' or 'phonepe_custom'
        console.log("📱 Scenario B: PhonePe Custom UPI Flow");
        console.log("Gateway:", paymentData.gateway);
        console.log("Payment Options:", JSON.stringify(paymentData.payment_options, null, 2));
        console.log("Has QR Data:", !!paymentData.payment_options?.qr_data);
        console.log("Has Intent URL:", !!paymentData.payment_options?.intent_url);
        console.log("Opening PhonePe Drawer...");
        
        setDrawerOrderId(paymentData.order_id);
        setDrawerPaymentOptions(paymentData.payment_options);
        setDrawerPaymentId(paymentData.payment_id);
        setDrawerVisible(true);
        setButtonLoading(false); // Stop button loading since drawer is handling it
      } else if (paymentData?.payment_url) {
        // Scenario C: Standard gateway redirect (Juspay, etc.)
        console.log("🔗 Scenario C: External Gateway Redirect");
        console.log("Gateway:", paymentData.gateway || 'juspay');
        console.log("Redirect URL:", paymentData.payment_url);
        console.log("Redirecting in 1 second...");
        
        trackCustomEvent(CUSTOM_EVENTS.PAYMENT_GATEWAY_REDIRECT, {
          gateway: paymentData.gateway || 'juspay',
          order_id: data.id,
          bundle_id: bundleId || null,
          payment_url: paymentData.payment_url
        }, ANALYTICS_PROVIDERS.AMPLITUDE);

        window.location.href = paymentData.payment_url;
      } else {
        // Scenario D: Error - no valid payment option
        console.error("❌ Scenario D: Invalid Payment Response");
        console.error("Full Response:", JSON.stringify(paymentData, null, 2));
        console.error("Missing: payment_url, gateway, and is_purchase_done flags");
        toast("Unable to process payment. Please try again.");
        setButtonLoading(false);
      }
    } catch (error) {
      console.error("Payment processing error:", error);
      
      // Track Payment Processing Error
      trackPaymentEvent('failed', {
        amount: 0,
        currency: 'INR',
        order_id: null,
        failure_reason: error.message || 'Payment processing error',
        stage: 'payment_link_generation'
      });
      
      toast("An error occurred. Please try again.");
      setButtonLoading(false);
    }
  };

  const RemoveCoupon = async () => {
    const params = {};
    if (bundleId) {
      params.bundle = bundleId;
    }
    const { data } = await Api[bundleId ? "BundleCheckout" : "GetOrderAmount"](
      params
    );
    setAppliedCoupon({ discountDetails: data });
  };
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    // Only apply phone number length restriction for non-USD currency
    if (name === "phone" && value.length > 10 && currencyType !== 'usd') {
      return;
    }
    setUserDetail((pre_state) => {
      return { ...pre_state, [name]: value };
    });
  };
  const eraseInput = (e) => {
    const name = e.target.name;
    setUserDetail((pre_state) => {
      return { ...pre_state, [name]: "" };
    });
  };
  const isAbleButton = () => {
    // For USD currency, only check email
    if (currencyType === 'usd') {
      return userDetail.email?.length > 0;
    }
    // For non-USD currency, check both email and phone number
    return userDetail.email?.length > 0 && userDetail.phone?.length === 10;
  };

  const openWhatsApp = () => {
    window.open(`https://wa.me/919148477518`, '_blank');
  }

  const getCurrencySymbol = (currency_type) => {
    return currency_type === 'usd' ? '$' : '₹';
  }

  // Get currency type from cart data or localStorage
  const currencyType = cartData[0]?.subscription_plan?.currency_type || localStorage.getItem('current_currency_type') || 'inr';
  const currencySymbol = getCurrencySymbol(currencyType);

  if (hasError) {
    return <ErrorFallback errorDetails={errorDetails} />;
  }
  if (loading) {
    return <Loading />;
  }

  let paymentDetails = cartData[0] || {};
  if (appliedCoupon && appliedCoupon.discountDetails && !bundleId) {
    const {
      total_cost: mrp_price,
      total_cost_calculated,
      final_payment_amount,
      coupon_code_value,
    } = appliedCoupon.discountDetails;
    paymentDetails = {
      mrp_price,
      cost: total_cost_calculated,
      actual_discounted_cost: final_payment_amount?.coin_and_no_money,
      coin_value_reserved:
        (final_payment_amount?.no_coin_and_no_money || 0) -
        (final_payment_amount?.coin_and_no_money || 0),
      couponDiscount: coupon_code_value,
    };
  } else if (paymentDetails) {
    paymentDetails.couponDiscount =
      appliedCoupon?.discountDetails?.coupon_code_value || 0;
    paymentDetails.cost =
      appliedCoupon?.discountDetails?.final_payment_amount?.no_coin_and_no_money || paymentDetails.cost;
    paymentDetails.actual_discounted_cost =
      appliedCoupon?.discountDetails?.final_payment_amount?.coin_and_no_money ||
      paymentDetails.actual_discounted_cost;
  }
  // Handle dismissing the payment failure banner
  const dismissPaymentBanner = () => {
    setShowPaymentBanner(false);
    // Replace the URL to remove query parameters
    const url = new URL(window.location.href);
    url.search = '';
    window.history.replaceState({}, '', url);
  };

  return (
    <>
      <ToastContainer />
      <PhonePeDrawer
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        orderId={drawerOrderId}
        paymentOptions={drawerPaymentOptions}
        paymentId={drawerPaymentId}
        onSuccess={() => {
          setDrawerVisible(false);
          navigate(`/order?order_id=${drawerOrderId}`);
        }}
      />
      {showPaymentBanner && (
        <div className={styles.paymentFailureBanner}>
          {paymentErrorReason === 'missing_order_id' 
            ? 'Payment verification failed. Please try again.' 
            : 'Payment failed. Please try again.'}
          <button 
            onClick={dismissPaymentBanner} 
            className={styles.dismissButton}
            aria-label="Dismiss"
          >
            ✕
          </button>
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.header}>
          <p className={cx(styles.headText, styles.mobile)}>Checkout</p>
          <img
            onClick={() => navigate(-1)}
            className={styles.chevronLeft}
            src={chevronLeft}
            alt="chevronLeft"
          />
        </div>
        <div className={styles.detailContainer}>
          <div className={styles.cardContainer}>
            <p className={cx(styles.headText, styles.desktop)}>Checkout</p>
            {cartData.map((d, i) => {
              return (
                <ProductPurchaseCard
                  useFleekCoin={useFleekCoin}
                  isDigital={false}
                  cartData={d}
                  key={i}
                />
              );
            })}
            {/* <FreeProductPurchaseCard/> */}
          </div>
          <div className={styles.otherDetail}>
            <UserPersonalDetailsCard
              userDetail={userDetail}
              handleChange={handleChange}
              eraseInput={eraseInput}
            />
            {cartData[0]?.coin_value_reserved &&
              Number(cartData[0].coin_value_reserved) ? (
              <FleekCoinDetailsCard
                fleekCoins={fleekCoins}
                useFleekCoin={useFleekCoin}
                toggleUseFleekCoin={toggleUseFleekCoin}
                cartData={cartData[0]}
              />
            ) : (
              <EarnFleekCoinsCard />
            )}
            {appliedCoupon.coupon_code ? (
              <div className={styles.appliedCoupanCard}>
                <img
                  src={GreenPercentCircle}
                  alt="GreenPercentCircle"
                  className={styles.circle}
                />
                <div className={styles.textContainer}>
                  <p className={styles.appliedCoupanText}>
                    {appliedCoupon.coupon_code} applied
                  </p>
                  <p className={styles.appliedSubText}>
                    Yay! You saved {currencySymbol}{appliedCoupon.amountSaved}
                  </p>
                </div>
                <p onClick={RemoveCoupon} className={styles.removeText}>
                  REMOVE
                </p>
              </div>
            ) : (
              <div
                onClick={() =>
                  isMobile ? navigate("/coupon") : toggleCoupanPopUp()
                }
                className={styles.applyCoupanCard}
              >
                <img
                  src={PercentCircle}
                  alt="PercentCircle"
                  className={styles.circle}
                />
                <p className={styles.coupantext}>Apply Coupon</p>
                <p className={styles.newText}>NEW</p>
                <img
                  src={chevronRight}
                  alt="chevronRight"
                  className={styles.chevronRight}
                />
              </div>
            )}
            <PaymentDetailsCard
              useFleekCoin={useFleekCoin}
              cartData={paymentDetails}
            />

            {/* Trust badges for increased conversion */}
            <div className={styles.trustBadges}>
              <div className={styles.trustBadge}>
                <span className={styles.trustIcon}>🔒</span>
                <span className={styles.trustText}>100% Secure Payments</span>
              </div>
              <div className={styles.trustBadge}>
                <span className={styles.trustIcon}>✅</span>
                <span className={styles.trustText}>Verified Brands</span>
              </div>
              <div className={styles.trustBadge}>
                <span className={styles.trustIcon}>🎁</span>
                <span className={styles.trustText}>Exclusive Offers</span>
              </div>
            </div>

            {/* WhatsApp Support Card */}
            <div className={styles.whatsappCard} onClick={openWhatsApp}>
              <div className={styles.whatsappContent}>
                <img src={whatsappIcon} alt="WhatsApp" className={styles.whatsappIcon} />
                <div className={styles.whatsappText}>
                  <p className={styles.whatsappTitle}>Having trouble checking out?</p>
                  <p className={styles.whatsappSubtitle}>WhatsApp us now</p>
                  <p className={styles.whatsappNumber}>+91 91484 77518</p>
                </div>
              </div>
              <img src={forward} alt="forward" className={styles.whatsappForward} />
            </div>

            <div className={styles.mobileButtonContainer}>
              <button
                onClick={PlaceOrder}
                className={
                  isAbleButton()
                    ? buttonLoading ? cx(styles.payButton, styles.loading) : styles.payButton
                    : cx(styles.payButton, styles.inactive)
                }
                disabled={!isAbleButton() || buttonLoading}
              >
                {buttonLoading ? (
                  <>
                    <span className={styles.loadingSpinner}></span>
                    PROCESSING...
                  </>
                ) : (
                  "PROCEED TO PAY"
                )}
              </button>
            </div>
            {/* <button className={cx(styles.payButton,styles.desktop)}>
                            PROCEED TO PAY
                        </button> */}
          </div>
        </div>
      </div>
      {(coupon || showCoupanPopUp) && (
        <CoupanPopUp
          appliedCoupon={appliedCoupon}
          toggleModal={toggleCoupanPopUp}
          toggleCoupanCongrats={toggleCoupanCongrats}
          cartData={cartData[0]}
        />
      )}

      {showCoupanCongratsPopUp && (
        <CouponCongrats
          appliedCoupon={appliedCoupon}
          toggleCoupanCongrats={toggleCoupanCongrats}
        />
      )}
    </>
  );
};
